module.exports = "/packs/015-f479eeff50c86e73e389b35abaaaf9dc.jpg";